import React from 'react'
import Buttons from '../../../ui/Buttons';
import styled from 'styled-components';
import { IconAsButton } from '../../../ui';
import { coursePageNavigation, drawerWidthMinimal, drawerWidthResponsive, drawerWidthResponsiveCompact } from '../../../utils/constants';
import { media } from '../../../utils/media';
import { getDarkerThemeColor } from '../../../ui/theme/colors';
import { useTranslation } from "react-i18next";

const IconAsButtonStyled = styled(IconAsButton)`
  position: absolute !important;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
  z-index: 999;
`;

const NavButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  display: flex;
  height: ${coursePageNavigation}px;
  justify-content: space-between;
  background-color: ${({ $backgroundColor }) => $backgroundColor} !important;
  width: ${(props) => {
    const tocWidth = props.$bothPanelsOpen ? drawerWidthResponsiveCompact : drawerWidthResponsive;
    return props.$isTocMenuClosed ? `calc(100% - ${drawerWidthMinimal}px)` : `calc(100% - ${tocWidth})`;
  }};
  transition: width 0.2s ease-in-out;

  ${media.greaterThan('bigTablet')} {
    width: ${(props) => {
      if (props.$compactSize) {
        // Notes drawer is open
        if (props.$bothPanelsOpen) {
          // Both panels open - use compact widths
          return props.$isTocMenuClosed
            ? `calc(100% - ${drawerWidthMinimal}px - ${drawerWidthResponsiveCompact})`
            : `calc(100% - ${drawerWidthResponsiveCompact} - ${drawerWidthResponsiveCompact})`;
        } else {
          // Only notes open - use regular width for notes
          return props.$isTocMenuClosed
            ? `calc(100% - ${drawerWidthMinimal}px - ${drawerWidthResponsive})`
            : `calc(100% - ${drawerWidthResponsive} - ${drawerWidthResponsive})`;
        }
      } else {
        // Notes drawer is closed
        const tocWidth = props.$bothPanelsOpen ? drawerWidthResponsiveCompact : drawerWidthResponsive;
        return props.$isTocMenuClosed
          ? `calc(100% - ${drawerWidthMinimal}px)`
          : `calc(100% - ${tocWidth})`;
      }
    }};
  }

  ${media.lessThan('tablet')} {
    width: 100%;
  }
`;

const NavButtons = React.memo(({ prev, next, goToPage, isTocMenuClosed, isNotesOpen, lightColor, darkColor, handleOpenNotes, themeColor, nextLocked }) => {
  const { t } = useTranslation();
  const bothPanelsOpen = !isTocMenuClosed && isNotesOpen;

  return (
    <NavButtonWrapper $isTocMenuClosed={isTocMenuClosed} $compactSize={isNotesOpen} $bothPanelsOpen={bothPanelsOpen} $backgroundColor={lightColor}>
      <Buttons.NavButton
        disabled={!prev || !prev.id}
        onClick={() => goToPage(prev?.id)}
        $align={'left'}
        label={prev?.name || ''}
        startIcon={'ArrowLeft'}
        $with={'calc(50% - 22px)'}
        $hoverColor={darkColor}
        $bgcolor={lightColor}
      />
      <IconAsButtonStyled
        iconName={'EditNote'}
        tooltipLabel={t('coursePage.notes.yourNotes')}
        color={getDarkerThemeColor(themeColor)}
        clickHandle={handleOpenNotes}
      />
      <Buttons.NavButton
        disabled={!next || !next.id || nextLocked}
        onClick={() => goToPage(next?.id)}
        $align={'right'}
        label={next?.name || ''}
        endIcon={'ArrowRight'}
        $with={'calc(50% - 22px)'}
        $hoverColor={darkColor}
        $bgcolor={lightColor}
      />
    </NavButtonWrapper>
  );
});

export default NavButtons;
